import axios from 'axios';
import { API_URL_TRENDING } from '../constantes/constantes';

// Mismo servicio que trending (go_search): /api/trending → /api/top_searches
const API_URL_TOP_SEARCHES = API_URL_TRENDING.replace(/\/trending\/?$/, '/top_searches');

/**
 * Obtiene las búsquedas más repetidas en UnoTV (lo que escriben los usuarios, sin LLM).
 *
 * @async
 * @param {AbortSignal|null} signal - Señal opcional para cancelar la petición.
 * @param {number} timeout - Tiempo máximo de espera en milisegundos.
 * @returns {Promise<{statusCode: number, data: Object|Array, aborted?: boolean}>}
 * `data.searches` es `[{query, count}]` ordenado de más a menos buscado.
 */
export async function getTopSearches(signal = null, timeout = 10000) {
  try {
    const response = await axios.get(API_URL_TOP_SEARCHES, {
      timeout,
      params: { source: 'utv', hours: 24, limit: 8, min_count: 3 },
      headers: { Accept: 'application/json' },
      ...(signal ? { signal } : {})
    });

    return {
      statusCode: response.status,
      data: response.data
    };
  } catch (error) {
    if (error.code === 'ERR_CANCELED' || error.name === 'AbortError') {
      return { statusCode: 499, data: [], aborted: true };
    }

    if (error.response) {
      return { statusCode: error.response.status, data: [] };
    }

    console.error('[getTopSearches] Error:', error.message, 'Code:', error.code);
    return { statusCode: 500, data: [] };
  }
}
